import { create } from 'zustand';
import type { GameState, Match, Card } from '../types';

interface GameStore {
  currentMatch: Match | null;
  gameState: GameState | null;
  isConnected: boolean;
  setCurrentMatch: (match: Match | null) => void;
  setGameState: (gameState: GameState | null) => void;
  setConnected: (connected: boolean) => void;
  updatePlayerHand: (playerId: number, hand: Card[]) => void;
  addCardToHand: (playerId: number, card: Card) => void;
  removeCardFromHand: (playerId: number, cardId: number) => void;
}

export const useGameStore = create<GameStore>((set, get) => ({
  currentMatch: null,
  gameState: null,
  isConnected: false,
  setCurrentMatch: (match) => set({ currentMatch: match }),
  setGameState: (gameState) => set({ gameState }),
  setConnected: (connected) => set({ isConnected: connected }),
  updatePlayerHand: (playerId, hand) => {
    const { gameState } = get();
    if (!gameState) return;
    
    set({
      gameState: {
        ...gameState,
        players: {
          ...gameState.players,
          [playerId]: {
            ...gameState.players[playerId],
            hand,
          },
        },
      },
    });
  },
  addCardToHand: (playerId, card) => {
    const { gameState } = get();
    if (!gameState || !gameState.players[playerId]) return;
    
    set({
      gameState: {
        ...gameState,
        players: {
          ...gameState.players,
          [playerId]: {
            ...gameState.players[playerId],
            hand: [...gameState.players[playerId].hand, card],
          },
        },
      },
    });
  },
  removeCardFromHand: (playerId, cardId) => {
    const { gameState } = get();
    if (!gameState || !gameState.players[playerId]) return;
    
    set({
      gameState: {
        ...gameState,
        players: {
          ...gameState.players,
          [playerId]: {
            ...gameState.players[playerId],
            hand: gameState.players[playerId].hand.filter(card => card.id !== cardId),
          },
        },
      },
    });
  },
}));
